





















import {
	defineComponent, PropType,
} from '@vue/composition-api';
import { v4 } from 'uuid';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import { Size, Spacing } from '@front-app/components/constants';
import SimpleInputSection from '@front-app/components/form/SimpleInputSection.vue';
import { EventManagementData } from '@front-app/services/EventsApi/EventModel';
import { syncedRef } from '@front-app/util/reactivity';
import { v } from '@front-app/components/form/validation/useValidation';
import { required } from '@front-app/components/form/validation/validators';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useEventAdminStore } from '../../store/EventAdmin';
import EditEventBaseForm from './EditEventBaseForm.vue';

export default defineComponent({
	components: {
		SimpleInputSection,
		EditEventBaseForm,
	},
	props: {
		eventData: {
			type: Object as PropType<EventManagementData>,
			required: true,
		},
	},
	setup(props, ctx) {
		const name = syncedRef(() => props.eventData.name).ref;

		// Validation
		const validation = v({
			name: {
				value: name,
				rules: [required()],
			},
		});

		const {
			track,
			isLoading: isSavingUpdates,
			isError: isErrorSavingUpdates,
			isSuccess: isSuccessSavingUpdates,
		} = useAsyncStatus();

		const formId = `event-form-${v4()}`;
		const { focusFirstInvalid } = useFocusFirstInvalidField({ containerSelector: `#${formId}` });

		const saveUpdates = async () => {
			validation.validate();
			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}
			await track(useEventAdminStore().update(props.eventData.id, { name: name.value }));

			if (isSuccessSavingUpdates.value) {
				ctx.emit('close');
			}
		};

		return {
			formId,
			name,
			validation,
			isSavingUpdates,
			isErrorSavingUpdates,
			saveUpdates,
			// Util
			Size,
			Spacing,
			ButtonPalettes,
		};
	},
});
